export { validateAndSanitizeDocContent } from './validators/validateDocContent';
export function quickSanitize(content: any[]): { content: any[]; success: boolean } {
  const { validateAndSanitizeDocContent } = require('./validators/validateDocContent');
  const result = validateAndSanitizeDocContent(content);
  return { content: result.sanitizedContent, success: result.isValid };
}


